export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const TOGGLE_MODAL = "TOGGLE_MODAL";

export const LIST_USER_PROFILE = "LIST_USER_PROFILE";
export const RESET_USER_PROFILE = "RESET_USER_PROFILE";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
